export const SpringTransition = {
  type: 'spring',
  stiffness: 250,
  damping: 15,
  duration: 0.12,
}
